import { useCallback, useState } from "react";

export type AsyncFunction<T, U extends unknown[]> = (...args: U) => Promise<T>;

export const useLoadingPromise = <T, U extends unknown[]>(
  asyncFunc: AsyncFunction<T, U>
): [boolean, AsyncFunction<T, U>] => {
  const [loading, setLoading] = useState(false);

  const wrappedPromise = useCallback(
    (...args: U): Promise<T> =>
      new Promise((resolve, reject) => {
        setLoading(true);
        asyncFunc(...args)
          .then(resolve)
          .catch(reject)
          .finally(() => setLoading(false));
      }),
    [asyncFunc]
  );

  return [loading, wrappedPromise];
};
